/**
 * Locale (es-ES) — Document Manager (AUTOMY's "Google Drive").
 * Reuses existing global keys where applicable; module-specific copy only here.
 */
export default {
  'documents.title': 'Documentos',
  'documents.summary': 'Organiza, sube y consulta todos los documentos del sistema en carpetas.',
  'documents.refresh': 'Actualizar',

  // Hero actions
  'documents.action.upload': 'Subir',
  'documents.action.newFolder': 'Nueva carpeta',
  'documents.action.exports': 'Mis exportaciones',

  // Breadcrumb
  'documents.breadcrumb.root': 'Mi unidad',
  'documents.breadcrumb.byProcess': 'Por proceso',
  'documents.breadcrumb.byProcessInstance': 'Por solicitud',
  'documents.breadcrumb.byForm': 'Por formulario',
  'documents.breadcrumb.byEntity': 'Por entidad',
  'documents.breadcrumb.byList': 'Por lista',
  'documents.breadcrumb.byChatThread': 'Por chat',

  // Grouping (virtual folders)
  'documents.groupBy.label': 'Ver por',
  'documents.groupBy.folder': 'Carpetas',
  'documents.groupBy.process': 'Proceso',
  'documents.groupBy.processInstance': 'Solicitud',
  'documents.groupBy.form': 'Formulario',
  'documents.groupBy.entity': 'Entidad',
  'documents.groupBy.list': 'Lista',
  'documents.groupBy.chatThread': 'Chat',
  'documents.group.none': 'Sin asignar',

  // View toggle
  'documents.view.list': 'Vista de lista',
  'documents.view.grid': 'Vista de mosaico',

  // Sections
  'documents.section.folders': 'Carpetas',
  'documents.section.files': 'Archivos',

  // Toolbar / order
  'documents.order.nameAsc': 'Nombre (A-Z)',
  'documents.order.nameDesc': 'Nombre (Z-A)',
  'documents.order.recent': 'Más recientes',
  'documents.order.oldest': 'Más antiguos',
  'documents.order.sizeDesc': 'Más pesados',
  'documents.order.sizeAsc': 'Más livianos',

  // Filters (panel same style as /applications)
  'documents.filters.toggle': 'Filtros',
  'documents.filters.clearAll': 'Limpiar filtros',
  'documents.filters.type': 'Tipo de archivo',
  'documents.filters.source': 'Origen',
  'documents.filters.process': 'Proceso',
  'documents.filters.owner': 'Propietario',
  'documents.filters.date': 'Fecha de creación',

  // List columns
  'documents.columns.name': 'Nombre',
  'documents.columns.owner': 'Propietario',
  'documents.columns.source': 'Origen',
  'documents.columns.size': 'Tamaño',
  'documents.columns.modified': 'Modificado',

  // Item actions
  'documents.item.open': 'Abrir',
  'documents.item.preview': 'Vista previa',
  'documents.item.details': 'Ver detalles',
  'documents.item.download': 'Descargar',
  'documents.item.rename': 'Renombrar',
  'documents.item.move': 'Mover',
  'documents.dnd.dropToMove': 'Suelta para mover aquí',
  'documents.item.delete': 'Eliminar',
  'documents.item.openRequest': 'Ir a la solicitud',

  // Details drawer (Drive-style info panel)
  'documents.details.title': 'Detalles',
  'documents.details.collapse': 'Ocultar detalles',
  'documents.details.expand': 'Mostrar detalles',
  'documents.details.close': 'Cerrar',
  'documents.details.general': 'Información general',
  'documents.details.context': 'Contexto en AUTOMY',
  'documents.details.type': 'Tipo',
  'documents.details.contentType': 'Tipo de contenido',
  'documents.details.size': 'Tamaño',
  'documents.details.owner': 'Propietario',
  'documents.details.created': 'Creado',
  'documents.details.updated': 'Última modificación',
  'documents.details.source': 'Origen',
  'documents.details.process': 'Proceso',
  'documents.details.request': 'Solicitud',
  'documents.details.form': 'Formulario',
  'documents.details.field': 'Campo',
  'documents.details.action': 'Acción',
  'documents.details.folder': 'Carpeta',
  'documents.zoom.in': 'Acercar',
  'documents.zoom.out': 'Alejar',
  'documents.zoom.reset': 'Restablecer zoom',
  'documents.zoom.loadError': 'No se pudo cargar la imagen.',

  // File type (AttachmentFileTypeClassification)
  'documents.type.unknown': 'Archivo',
  'documents.type.image': 'Imagen',
  'documents.type.video': 'Video',
  'documents.type.pdf': 'PDF',
  'documents.type.word': 'Word',
  'documents.type.excel': 'Excel',
  'documents.type.powerPoint': 'PowerPoint',
  'documents.type.microsoftProject': 'Microsoft Project',
  'documents.type.text': 'Texto',
  'documents.type.xml': 'XML',
  'documents.type.html': 'HTML',
  'documents.type.json': 'JSON',
  'documents.type.zip': 'ZIP',
  'documents.type.audio': 'Audio',
  'documents.type.rar': 'RAR',
  'documents.type.font': 'Fuente',
  'documents.type.textCsv': 'CSV',
  'documents.type.androidApk': 'Android APK',
  'documents.type.exeFile': 'Ejecutable',
  'documents.type.parquetFile': 'Parquet',
  'documents.type.outlookMessage': 'Mensaje Outlook',
  'documents.type.markdown': 'Markdown',

  // Document source (DocumentSource)
  'documents.source.processInstanceFormFieldAttachment': 'Adjunto de formulario',
  'documents.source.processInstanceGeneratedDocument': 'Documento generado',
  'documents.source.processInstanceVariableAttachment': 'Adjunto de variable',
  'documents.source.processInstanceCommentAttachment': 'Adjunto de comentario',
  'documents.source.entityAttachment': 'Adjunto de entidad',
  'documents.source.processInstanceApiCallAttachment': 'Adjunto de API',
  'documents.source.listExportGeneratedFile': 'Exportación de lista',
  'documents.source.dynamicEntityExportGeneratedFile': 'Exportación de entidad',
  'documents.source.dynamicEntityImportGeneratedErrorFile': 'Errores de importación',
  'documents.source.processInstanceOpenAICallAttachment': 'Adjunto de IA',
  'documents.source.processInstanceAutomyAIAttachment': 'Adjunto de Automy AI',
  'documents.source.processInstanceRunCodeAttachment': 'Adjunto de código',
  'documents.source.chatThreadAttachment': 'Adjunto de chat',
  'documents.source.configurationEntityExportGeneratedFile': 'Exportación de configuración',
  'documents.source.configurationEntityImportGeneratedErrorFile': 'Errores de importación (config)',
  'documents.source.manualUpload': 'Subida manual',
  'documents.source.documentManagerBulkExportGeneratedFile': 'Exportación masiva',

  // Selection / bulk export
  'documents.selection.select': 'Seleccionar',
  'documents.selection.deselect': 'Quitar selección',
  'documents.selection.count': '{count, plural, one {# documento} other {# documentos}} · {size}',
  'documents.selection.countFolders':
    '{count, plural, one {# carpeta} other {# carpetas}} (se incluyen sus archivos)',
  'documents.selection.countMixed':
    '{documents, plural, one {# documento} other {# documentos}}, {folders, plural, one {# carpeta} other {# carpetas}} · {size}',
  'documents.selection.limitsHint': 'Puedes exportar hasta {max} elementos o 5 GB',
  'documents.selection.limitReachedCount': 'Llegaste al tope de {max} elementos',
  'documents.selection.limitReachedSize': 'La selección supera el límite de 5 GB',
  'documents.selection.bulkLimitHint':
    'Para mover o eliminar, selecciona como máximo {max} elementos',
  'documents.selection.selectVisible': 'Seleccionar visibles',
  'documents.selection.clear': 'Limpiar selección',
  'documents.export.action': 'Exportar selección',
  'documents.export.exporting': 'Exportando...',
  'documents.export.emptySelection': 'Selecciona al menos un documento o carpeta.',
  'documents.export.maxCount': 'Puedes exportar como máximo {max} elementos por vez.',
  'documents.export.maxSize': 'La selección supera el tamaño máximo de 5 GB.',
  'documents.export.started':
    'Exportación {taskNumber} iniciada ({count} elemento(s)). Te avisaremos cuando esté lista.',
  'documents.export.pending': 'Exportación en cola',
  'documents.export.processing': 'Generando ZIP...',
  'documents.export.ready': 'Exportación lista para descargar',
  'documents.export.failed': 'Error en la exportación',
  'documents.export.summary': '{exported} exportado(s) · {skipped} omitido(s)',
  'documents.export.download': 'Descargar ZIP',
  'documents.export.dismiss': 'Cerrar',

  'documents.bulk.move': 'Mover',
  'documents.bulk.delete': 'Eliminar',
  'documents.bulk.moveTitle': 'Mover selección',
  'documents.bulk.deleteTitle': 'Eliminar selección',
  'documents.bulk.moveConfirm':
    'Vas a mover {count} elemento(s) ({documents} documento(s), {folders} carpeta(s)).',
  'documents.bulk.deleteConfirm':
    '¿Seguro que deseas eliminar {count} elemento(s)? Esta acción no se puede deshacer.',
  'documents.bulk.deleteConfirmCascade':
    '¿Seguro que deseas eliminar {count} elemento(s) ({documents} documento(s), {folders} carpeta(s))? Las carpetas se eliminan en cascada con todo su contenido.',
  'documents.bulk.maxItems': 'Puedes mover o eliminar como máximo {max} elementos a la vez.',
  'documents.msg.bulkMoved': 'Elementos movidos.',
  'documents.msg.bulkDeleted': 'Elementos eliminados.',

  // My exports drawer
  'documents.exportTasks.title': 'Mis exportaciones',
  'documents.exportTasks.subtitle': 'ZIPs generados desde Documentos. Disponibles por 7 días.',
  'documents.exportTasks.empty': 'Aún no tienes exportaciones',
  'documents.exportTasks.emptyHint':
    'Selecciona documentos o carpetas y usa “Exportar selección” para generar un ZIP.',
  'documents.exportTasks.generating': 'Generando archivo…',
  'documents.exportTasks.expires': 'Disponible hasta {date}',
  'documents.exportTasks.loadMore': 'Cargar más',
  'documents.exportTasks.loadingMore': 'Cargando…',
  'documents.exportTasks.status.pending': 'En cola',
  'documents.exportTasks.status.processing': 'Procesando',
  'documents.exportTasks.status.processed': 'Lista',
  'documents.exportTasks.status.error': 'Error',
  'documents.exportTasks.status.cancelled': 'Cancelada',

  // Empty
  'documents.empty.title': 'Esta carpeta está vacía',
  'documents.empty.description': 'Sube documentos o crea una carpeta para empezar a organizar.',
  'documents.empty.search': 'No encontramos resultados para tu búsqueda o filtros.',

  // Modals — folder
  'documents.folder.newTitle': 'Nueva carpeta',
  'documents.folder.renameTitle': 'Renombrar carpeta',
  'documents.folder.nameLabel': 'Nombre de la carpeta',
  'documents.folder.namePlaceholder': 'Sin título',
  'documents.folder.colorLabel': 'Color',

  // Modals — document rename
  'documents.document.renameTitle': 'Renombrar documento',
  'documents.document.nameLabel': 'Nombre del archivo',

  // Modals — upload
  'documents.upload.title': 'Subir documentos',
  'documents.upload.dragText': 'Arrastra archivos o carpetas aquí',
  'documents.upload.hint':
    'También puedes elegirlos abajo. Si sueltas una carpeta, se crea con todo su contenido.',
  'documents.upload.browse': 'Elegir archivos',
  'documents.upload.browseFolder': 'Elegir carpeta',
  'documents.upload.addMore': 'Agregar archivos',
  'documents.upload.addMoreFolder': 'Agregar carpeta',
  'documents.upload.selected': '{count} archivo(s) · {size}',
  'documents.upload.selectedWithFolders': '{files} archivo(s) · {folders} carpeta(s) · {size}',
  'documents.upload.clearAll': 'Quitar todos',
  'documents.upload.removeFile': 'Quitar archivo',
  'documents.upload.submit': 'Subir',
  'documents.upload.submitCount': 'Subir {count}',
  'documents.upload.uploading': 'Subiendo...',
  'documents.upload.progressFolders': 'Creando carpetas ({current}/{total})',
  'documents.upload.progressFiles': 'Subiendo archivos ({current}/{total})',
  'documents.upload.dropHere': 'Suelta para subir aquí',
  'documents.upload.dropHereHint': 'Archivos y carpetas van a la carpeta actual',

  // Modals — move
  'documents.move.title': 'Mover a',
  'documents.move.destinationLabel': 'Carpeta de destino',
  'documents.move.root': 'Mi unidad (raíz)',
  'documents.move.submit': 'Mover aquí',

  // Modals — delete
  'documents.delete.folderTitle': 'Eliminar carpeta',
  'documents.delete.documentTitle': 'Eliminar documento',
  'documents.delete.folderConfirm':
    '¿Seguro que deseas eliminar la carpeta "{name}"? Esta acción no se puede deshacer.',
  'documents.delete.documentConfirm': '¿Seguro que deseas eliminar el documento "{name}"?',

  // Messages
  'documents.msg.folderCreated': 'Carpeta creada.',
  'documents.msg.folderRenamed': 'Carpeta renombrada.',
  'documents.msg.folderMoved': 'Carpeta movida.',
  'documents.msg.folderDeleted': 'Carpeta eliminada.',
  'documents.msg.documentUploaded': 'Documento(s) subido(s).',
  'documents.msg.documentRenamed': 'Documento renombrado.',
  'documents.msg.documentMoved': 'Documento movido.',
  'documents.msg.documentDeleted': 'Documento eliminado.',
  'documents.msg.error': 'Ocurrió un error. Inténtalo nuevamente.',

  // Meta
  'documents.meta.items': '{count} elementos',
  'documents.meta.folderSuffix': 'carpeta',
  'documents.meta.folderSuffixPlural': 'carpetas',
};
